module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4315d75f8ed05856ec4150b800b683ad.png";